/* eslint-disable no-undef */
import { useFabricStore } from "@/stores/fabricModule";
import { PPI_RATIO } from '@/box/constants';
import { generateId } from "@/utils/common";
import customFabric from '@/fabric/index';
const {
  createFabricObject
} = customFabric;
const DEFAULT_TEXT_OBJECT = {
  objectType: "text",
  type: "i-text",
  id: `obj-${generateId()}`,
  top: 0,
  left: 0,
  fontFamily: "Arial",
  fontSize: 124,
  centerTransform: true,
  originX: "center",
  originY: "center",
  lockUniScaling: true,
  fill: "black",
  defaultText: "Edit text..."
};
const BASE_FONT_SIZE = 16;
const SIZE_MAPPING = {
  "small": BASE_FONT_SIZE * 4,
  // 64
  "medium": BASE_FONT_SIZE * 6,
  // 96
  "large": BASE_FONT_SIZE * 8,
  // 128
  "default": BASE_FONT_SIZE * 8 // 128
};

/**
 * @param {Object||String} complete JSON text object or string (size)
 * @returns {Object}
 */
export function useCreateEditorText(obj) {
  const fabricStore = useFabricStore();
  const {
    canvasWidth,
    canvasHeight
  } = storeToRefs(fabricStore);
  if (!obj || obj.isNew) {
    DEFAULT_TEXT_OBJECT.fontSize = SIZE_MAPPING[obj.size] || SIZE_MAPPING.default;
    delete obj.isNew;
    delete obj.size;
    obj = Object.assign(DEFAULT_TEXT_OBJECT, obj);
    obj.top = canvasHeight.value / 2;
    obj.left = canvasWidth.value / 2;
  }
  const textObj = createFabricObject(obj);
  textObj.scaleX = textObj.scaleX * PPI_RATIO;
  textObj.scaleY = textObj.scaleY * PPI_RATIO;
  return textObj;
}